import { render, staticRenderFns } from "./RiverSections.vue?vue&type=template&id=5eace5b7&scoped=true&"
import script from "./RiverSections.vue?vue&type=script&lang=js&"
export * from "./RiverSections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eace5b7",
  null
  
)

export default component.exports